// frontend/src/CategorizeAndClean/CategorizeAndClean.jsx — /categorize-and-clean/<tab> and /categorize-and-clean/products/<id>.
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Page, Tabs, Toast } from '@shopify/polaris';
import { cacApi } from './apiClient';
import DictionaryTab from './DictionaryTab';
import ProductPage from './ProductPage';
import ReviewTab from './ReviewTab';
import RunsTab from './RunsTab';
import StatusTiles from './StatusTiles';
import { TABS, parseTab, tabPath } from './routes';

export default function CategorizeAndClean() {
  const { tab: tabParam, id } = useParams();
  const navigate = useNavigate();
  const tab = useMemo(() => parseTab(tabParam), [tabParam]);
  const [toast, setToast] = useState(null);
  const notify = useCallback((content, error = false) => setToast({ content, error, key: Date.now() }), []);
  const [dictionary, setDictionary] = useState(null);
  const reloadDictionary = useCallback(() => cacApi.dictionary().then((r) => setDictionary(r.facets)).catch(() => {}), []);
  useEffect(() => { reloadDictionary(); }, [reloadDictionary]);
  useEffect(() => { if (!id && !tab) navigate(tabPath('review'), { replace: true }); }, [id, tab, navigate]);

  const toastEl = toast && <Toast key={toast.key} content={toast.content} error={toast.error} duration={toast.error ? 6000 : 3500} onDismiss={() => setToast(null)} />;
  if (id) {
    return (
      <Page title="Product" fullWidth>
        <ProductPage id={id} dictionary={dictionary} notify={notify} reloadDictionary={reloadDictionary} />
        {toastEl}
      </Page>
    );
  }
  if (!tab) return null;
  const tabs = TABS.map(([tid, content]) => ({ id: tid, content, panelID: `${tid}-panel` }));
  return (
    <Page title="Categorize & Clean" subtitle="Category and metafields for every product, reviewed and written from one list" fullWidth>
      <Tabs tabs={tabs} selected={TABS.findIndex(([t]) => t === tab)} onSelect={(i) => navigate(tabPath(TABS[i][0]))} />
      <div style={{ paddingTop: 16 }}>
        {tab === 'review' && <><StatusTiles /><ReviewTab notify={notify} dictionary={dictionary} /></>}
        {tab === 'dictionary' && <DictionaryTab dictionary={dictionary} reloadDictionary={reloadDictionary} notify={notify} />}
        {tab === 'runs' && <RunsTab notify={notify} />}
      </div>
      {toastEl}
    </Page>
  );
}
